import React, { Component } from 'react';
import classNames from 'classnames';
import { observer, inject } from 'mobx-react'
import { config } from '~/constants/config';

@inject("panelStore") @observer 
export default class ToogleButton extends Component {
  constructor(props){
    super(props)
  }
  render() {
    let { panelStatus, togglePanel } = this.props.panelStore;
    let buttonClass = classNames(
      'billy-active-button', 
      'billy-button', {
      'billy-active': panelStatus.isToggleOn
    })  
    return (
      <button className={ buttonClass } 
              aria-label={`${ panelStatus.isToggleOn ? 'סגור' : 'פתח' } מסך`}
              onClick={ togglePanel }>
        <img src={`${config.ROOT}/static/images/toggle-button.svg`} width="100%" aria-hidden="true" />
      </button>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/ToggleButton/index.js